import React, { useEffect, useState } from "react"
import Marquee from "react-marquee-slider"

const agencies = [
  {
    name: "Horizon Media",
    logo: require("../images/agency-logos/horizon.svg"),
  },
  { name: "PMG", logo: require("../images/agency-logos/pmg.svg") },
  { name: "Canvas", logo: require("../images/agency-logos/canvas.svg") },
  { name: "Omd", logo: require("../images/agency-logos/omd.svg") },
  { name: "Havas", logo: require("../images/agency-logos/havas.svg") },
  { name: "Zenith", logo: require("../images/agency-logos/zenith.svg") },
  { name: "Mindshare", logo: require("../images/agency-logos/mindshare.svg") },
  { name: "Rise", logo: require("../images/agency-logos/rise.svg") },
  { name: "UM", logo: require("../images/agency-logos/um.svg") },
  { name: "Mekanism", logo: require("../images/agency-logos/mekanism.svg") },
  {
    name: "Merkley + Partners",
    logo: require("../images/agency-logos/mp.svg"),
  },
  {
    name: "Worldwide Agency",
    logo: require("../images/agency-logos/wagency.svg"),
  },
]

const AgenciesMarquee = ({
  title = "Join Leading Agencies Activating inPowered AI",
  elements = agencies,
}) => {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  return (
    <div className="agencies-marquee">
      <h2 className="has-text-centered is-size-5 px-4 py-4-desktop">{title}</h2>

      {/* Desktop */}
      <div className="pt-6 is-hidden-touch pb-4">
        {isClient && (
          <Marquee velocity={16} style={{ display: "flex" }}>
            {elements.map(el => (
              <div className="px-6" key={el.name}>
                <img src={el.logo} alt={el.name} style={{ height: 50 }} />
              </div>
            ))}
          </Marquee>
        )}
      </div>

      {/* Mobile */}
      <div className="is-hidden-desktop">
        {isClient && (
          <Marquee velocity={16} style={{ display: "flex" }}>
            {elements.map(el => (
              <div className="px-6" key={el.name}>
                <img src={el.logo} alt={el.name} style={{ height: 50 }} />
              </div>
            ))}
          </Marquee>
        )}
      </div>
    </div>
  )
}

export default AgenciesMarquee
